import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20cinema%20themed%20abstract%20background%20with%20soft%20golden%20spotlight%20and%20film%20reel%20textures%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20artistic%20bokeh%20effect%2C%20luxurious%20theater%20curtain%20fabric%20texture%2C%20cinematic%20atmosphere%2C%20soft%20gradient%20lighting%2C%20elegant%20and%20sophisticated%20composition%2C%20no%20text&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="北条麻妃电影全集精选"
        title="北条麻妃电影全集精选 - 高清资源导航"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
          北条麻妃电影
          <span className="block text-primary-400 mt-2">全集精选</span>
        </h1>
        <p className="text-background-200 text-sm md:text-lg max-w-2xl leading-relaxed">
          探索北条麻妃电影完整作品列表，涵盖高清影片资源、经典代表作介绍与在线观看指南。为影迷提供最全面的北条麻妃电影信息汇总。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/featured"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-film-line"></i>
            浏览全部作品
          </Link>
          <Link
            to="/article/5"
            className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium px-6 py-3 rounded-full backdrop-blur-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-background-50/20"
          >
            <i className="ri-guide-line"></i>
            观影指南
          </Link>
        </div>
        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">12+</div>
            <div className="text-xs text-background-400 mt-1 whitespace-nowrap">精选作品</div>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">4.7</div>
            <div className="text-xs text-background-400 mt-1 whitespace-nowrap">平均评分</div>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">5</div>
            <div className="text-xs text-background-400 mt-1 whitespace-nowrap">作品分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}